module.exports = __webpack_public_path__ + "static/media/phoneCircleIcon.1081b3df.svg";